module.exports = __webpack_public_path__ + "static/media/link.678d9c04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/registry/importRegistryAccountPage/link.svg
// module id = 2598
// module chunks = 51